import React, { useEffect, useState } from "react";
import { Table, Form, Row, Col } from "react-bootstrap";
import {
  FiPlus,
  FiHome,
  FiChevronRight,
  FiEdit,
  FiTrash2,
} from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getExam } from "../../store/slices/exam";
import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { getsetMarks, deleteSetMarks } from "../../store/slices/setmarks";

import { toast } from "react-hot-toast";

const getAcademicSession = () => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth(); // Jan = 0, March = 2, April = 3

  // January, February, March
  if (currentMonth <= 2) {
    return `${currentYear - 1}-${String(currentYear).slice(-2)}`;
  }

  // April to December
  return `${currentYear}-${String(currentYear + 1).slice(-2)}`;
};


export default function SetMarks() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    session: getAcademicSession(),
    standardId: "",
    examId: "",
  });

  const [standards, setStandards] = useState([]);
  const [exams, setExams] = useState([]);
  const [marks, setMarks] = useState([]);
  const [errors, setErrors] = useState({});


  useEffect(() => {
    dispatch(fetchStandardSection())
      .unwrap()
      .then((res) => {
        setStandards(res?.data || []);
      })
      .catch((err) => toast.error(err));

    dispatch(getExam())
      .unwrap()
      .then((res) => {
        setExams(res?.data || []);
      })
      .catch((err) => toast.error(err));
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  useEffect(() => {
    if (!formData.standardId || !formData.examId) return;

    dispatch(
      getsetMarks({
        session: formData.session,
        standardId: formData.standardId,
        examId: formData.examId,
      })
    )
      .unwrap()
      .then((res) => {
        setMarks(res?.data || []);
      })
      .catch((err) => {
        toast.error(err || "Failed to fetch marks");
        setMarks([]);
      });
  }, [
    dispatch,
    formData.standardId,
    formData.examId,
    formData.session,
  ]);

  const handleDelete = (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this marks configuration?"
    );

    if (!confirmDelete) return;

    dispatch(deleteSetMarks(id))
      .unwrap()
      .then((message) => {
        toast.success(message || "Marks configuration deleted successfully");

        setMarks([]);

        // Optional: clear filters
        // setFormData((prev) => ({
        //   ...prev,
        //   standardId: "",
        //   examId: "",
        // }));
      })
      .catch((err) => {
        toast.error(err || "Failed to delete marks configuration");
      });
  };
  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">
          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home">
                <FiHome style={{ color: "white", marginTop: "-4px" }} />
              </Link>
            </div>
            <FiChevronRight className="separator" />

            <span className="active">Result</span>
            <FiChevronRight className="separator" />

            <span className="active">Set Marks</span>
          </div>

          <Link
            to="/institute/add-set-marks"
            className="add-btn"
          >
            <FiPlus />
            Add New
          </Link>
        </div>
      </div>

      <div className="staff-card">
        <Form >

          <Row className="g-3">
            <Col md={3}>
              <Form.Label>Session</Form.Label>

              <Form.Control
                type="text"
                name="session"
                value={formData.session}
                readOnly
              />
            </Col>

            {/* Standard */}
            <Col md={3}>
              <Form.Label>Standard</Form.Label>
              <Form.Select
                name="standardId"
                value={formData.standardId}
                onChange={handleChange}
              >
                <option value="">Select Standard</option>

                {standards.map((item) => (
                  <option
                    key={item.standardId._id}
                    value={item.standardId._id}
                  >
                    {item.standardId.name}
                  </option>
                ))}
              </Form.Select>
              {errors.standardId && (
                <small className="text-danger">
                  {errors.standardId}
                </small>
              )}
            </Col>

            {/* Section  */}
            <Col md={3}>

              <Form.Label>Exam</Form.Label>

              <Form.Select
                name="examId"
                value={formData.examId}
                onChange={handleChange}
                disabled={!formData.standardId}
              >
                <option value="">Select Exam</option>

                {exams.map((exam) => (
                  <option key={exam._id} value={exam._id}>
                    {exam.name}
                  </option>
                ))}
              </Form.Select>

              {errors.examId && (
                <small className="text-danger">
                  {errors.examId}
                </small>
              )}
            </Col>


          </Row>
        </Form>
        {formData.standardId && formData.examId && (
          <>
            {marks.length === 0 ? (
              <div className="text-center py-5">
                <h6>No marks configuration found.</h6>
                <p className="text-muted mb-0">
                  No marks have been configured for the selected Standard and Exam.
                </p>
              </div>
            ) : (
              <div className="table-responsive mt-5">
                <div className="d-flex justify-content-end gap-2 mb-3">
                  <button
                    type="button"
                    className="edit-btn"
                    onClick={() =>
                      navigate(`/institute/edit-set-marks/${marks[0]._id}`)
                    }
                  >
                    <FiEdit className="me-1" />

                  </button>

                  <button
                    type="button"
                    className="edit-btn"
                    onClick={() => handleDelete(marks[0]._id)}
                  >
                    <FiTrash2 />
                  </button>
                </div>

                <Table className="staff-table align-middle">
                  <thead>
                    <tr>
                      <th className="text-center">#</th>
                      <th className="text-center">Subject</th>
                      <th className="text-center">Type</th>
                      <th className="text-center">Maximum Marks</th>
                      <th className="text-center">Pass Marks</th>
                    </tr>
                  </thead>

                  <tbody>
                    {marks[0].subjects.map((subject, index) => (
                      <tr key={subject._id}>
                        <td className="text-center">{index + 1}</td>

                        <td className="text-center">
                          {subject.subjectId?.name}
                        </td>

                        <td className="text-center">
                          {subject.type}
                        </td>

                        <td className="text-center">
                          {subject.maxMarks}
                        </td>

                        <td className="text-center">
                          {subject.passMarks}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </>
        )}

      </div>
    </>
  );
}